import React from 'react';
import _orderBy from 'lodash-es/orderBy';
import 'twin.macro';
import { useFieldsToDisplay } from 'containers/CahierJournal/Toolbar/Filters/FieldsToDisplay/atom';
import { Attachment } from 'types/attachment';
import { Color } from 'types/colors';

import { CJAtelier } from 'types/cj';
import { Informations } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/Informations';
import { BOLabels } from 'types/user';
import HtmlViewer from 'components/HtmlViewer';
import { Flow } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/Activities';
import { GroupTag } from 'containers/CahierJournal/components/GroupTag';
import { SupervisionTag } from 'containers/CahierJournal/components/SupervisionTag';
import tw, { css } from 'twin.macro';
import { BasicEleveInfo } from 'types/eleveGroups';
import { NewAttachmentLinks } from 'components/Attachments/NewAttachmentLinks';
import { TagColorWithIntensity } from '@teetsh/app/src/styles/userConstants';
import clsx from 'clsx';

interface Props {
  atelier: CJAtelier;
  groups: Array<{
    name: string;
    color: Color | TagColorWithIntensity;
    eleves: BasicEleveInfo[];
    isEphemeral?: boolean;
  }>;
  attachments: Attachment[];
  boLabels: BOLabels;
  onClick?: (event: React.MouseEvent) => void;
  onChange?: (v: CJAtelier) => void;
  print: boolean;
  breakInsideAvoid?: boolean;
}

export function AtelierCard(props: Props) {
  const { print, atelier, boLabels, attachments, onClick } = props;
  const fieldsToDisplay = useFieldsToDisplay();

  return (
    <div
      className={clsx({
        'atelier-card': true,
        'break-inside-avoid': props.breakInsideAvoid,
        'break-inside-auto': !props.breakInsideAvoid,
      })}
      tw="flex flex-col p-2 hover:border-neutral-quiet gap-y-1"
      onClick={onClick}
    >
      <div tw="flex flex-wrap gap-1">
        <div tw="flex items-center flex-wrap gap-x-2 gap-y-1 min-w-0">
          <SupervisionTag supervision={atelier.supervision} />
          {_orderBy(props.groups, 'name', ['asc']).map(g => (
            <GroupTag
              interactive
              key={g.name}
              color={g.color || 'gris-moderate'}
              groupName={g.name}
              withElevesDetails={!print}
              groupEleves={g.eleves}
              print={print}
              isEphemeral={g.isEphemeral}
            />
          ))}
          <div tw="text-sm font-bold flex-grow truncate hover:underline">
            {atelier.title}
          </div>
        </div>
      </div>
      <div
        css={[
          css`
            &:not(:has(> *)) {
              ${tw`hidden`}
            }

            &:has(> *) {
              ${tw`flex flex-col gap-y-1`}
            }
          `,
        ]}
      >
        <Informations
          bo={atelier.bo}
          materials={atelier.materials}
          customFields={[]}
          boLabels={boLabels}
          print={print}
          customFieldDefinitions={[]} // TODO On voit ça plus tard
        />

        {atelier.flow && fieldsToDisplay?.includes('Activités') && (
          <Flow className="flow">
            <HtmlViewer
              text={atelier.flow}
              onChange={v => props?.onChange?.({ ...atelier, flow: v })}
              print={print}
            />
          </Flow>
        )}

        {fieldsToDisplay?.includes('attachments') &&
          (attachments || [])?.length > 0 && (
            <NewAttachmentLinks
              tw="mb-1"
              showTitle={false}
              showFileSize={!print}
              attachments={attachments}
            />
          )}
      </div>
    </div>
  );
}
